// import ProppinHeader from "component/layout/ProppinHeader";
import { ReactNode } from 'react';
import { ErrorBoundary } from 'react-error-boundary';
import { useNavigate } from 'react-router-dom';
import { useRecoilState } from 'recoil';
import { AcctState } from 'stores/atoms/acctState';
/**
 *　アプリケーション共通 例外ハンドラコンポーネント
 */
export default function AppErrorBoundary(props: { children: ReactNode }): JSX.Element {
  /* ----------------------------------------------------------------------- */
  /* 変数定義 */
  /* ----------------------------------------------------------------------- */
  const navigate = useNavigate();
  const [acctState, setAcctState] = useRecoilState(AcctState);
  /* ----------------------------------------------------------------------- */
  /* プライベート関数定義 */
  /* ----------------------------------------------------------------------- */
  const onReset = () => {
    if (acctState?.proxyLogin) {
      setAcctState(prev => ({
        ...prev,
        user: prev.user
          ? {
              ...prev.user,
              companies: [],
            }
          : prev.user,
      }));
    }
    navigate('/');
  };
  const fallbackComponent = ({ resetErrorBoundary }: { resetErrorBoundary: () => void }) => {
    // document.title = AppHelper.getPageTitle("500");
    return (
      <>
        <main>
          <section className="section-404 vh-100">
            <div className="container">
              <div className="align-middle d-flex flex-column justify-content-center align-items-center">
                <img
                  src="/img/common/logo.svg"
                  alt="BranQ ブランク"
                  className="d-block mx-auto card-logo"
                />
                <h3>500 INTERNAL SERVER ERROR</h3>
                <p className="text-center">
                  システムエラーが発生しました。時間をおいて再度お試しください。
                  <br />
                  何度も同様のエラーが表示される場合は、管理者に連絡してください。
                </p>
                <a
                  onClick={resetErrorBoundary}
                  className="btn btn-common d-inline-block moderate-blue"
                >
                  HOMEに戻る
                </a>
              </div>
            </div>
          </section>
        </main>
      </>
    );
  };
  /* ----------------------------------------------------------------------- */
  /* JSX */
  /* ----------------------------------------------------------------------- */
  return (
    <ErrorBoundary FallbackComponent={fallbackComponent} onReset={onReset}>
      {props.children}
    </ErrorBoundary>
  );
}
